document.addEventListener("DOMContentLoaded", function() {
  const params = new URLSearchParams(window.location.search);
  const tabIndex = params.get('tab');

  if (tabIndex) {
    // aspetta un po' perché Elementor carica le tab dopo il DOM
    setTimeout(() => {
      const targetButton = document.querySelector(`.e-n-tab-title[data-tab-index="${tabIndex}"]`);
      if (targetButton) {
        targetButton.click();
      }
    }, 300); // se serve, puoi aumentare questo valore
  }
});


// WEBPACK FOOTER //
// ./js/widget/tab-support.js